import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import AnimateHeight from 'react-animate-height'
import {equals} from "ramda"

class SubMenuWrapper extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
      isActive: false
    }
  }

  renderArrow = () => {
    if(!this.props.isSideBarOpen) return

    const arrowClass = 'fa-chevron-' + (this.state.isOpen? 'down' : 'left')

    return <i className={`fa ${arrowClass}`} aria-hidden="true" />
  }

  renderLabel = () => {
    return (<a href='#' className='submenu-header' onClick={e => e.preventDefault()}>
      <i className={this.props.iconClass} aria-hidden="true" />
      <span>{this.props.label}</span>
      {this.renderArrow()}
    </a>)
  }

  toggleOpen = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }

  componentDidMount = () => {
    this.handleStateChange()
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.pathname !== this.props.pathname) {
      this.handleStateChange()
    }
  }

  handleStateChange = () => {
    const childrenStatus = this.hasActiveChild()
    const nextState = {
      isActive: childrenStatus,
      isOpen: childrenStatus
    }
    if(!equals(this.state, nextState)) {
      this.setState(nextState)
    }
  }

  hasActiveChild = () => {
    if (!React.Children.count(this.props.children)) {
      return false
    }

    const children = React.Children.toArray(this.props.children)
    return (children.filter((child) => {
        return child.props.url === this.props.pathname
      }).length > 0)
  }

  render() {
    const classes = classNames({
      'active-parent': this.state.isActive || this.hasActiveChild(),
      'submenu-wrapper': true,
      open: this.state.isOpen,
    })

    return (
      <div className={`${classes} ${this.props.className}`} onClick={this.toggleOpen}>
        {this.renderLabel()}
        {/* {this.state.isOpen && */}
          <AnimateHeight
          duration={ 500 }
          height={ this.state.isOpen? 'auto' : 0 } // see props documentation bellow
          >
          {/* TODO: use a children map function here to add a click handler to all children using
              an HOC and update parent open and active state in the callback from that function
            */}
            {this.props.children}
          </AnimateHeight>
        {/* } */}
      </div>
    )
  }
}

SubMenuWrapper.PropTypes = {
  isSideBarOpen: PropTypes.bool,
  label: PropTypes.string.isRequired,
  iconClass:  PropTypes.string,
  clasName: PropTypes.string
}

SubMenuWrapper.defaultProps = {
  label: '',
  iconClass: 'fa fa-arrow-left'
}

const mstp = state => ({
  pathname: state.routing.locationBeforeTransitions.pathname
})

export default connect(mstp)(SubMenuWrapper)


// WEBPACK FOOTER //
// ./src/components/common/SidebarMenu/SubMenuWrapper.js